"use client";

import React from "react";

import { Box, Stack, Typography, Radio } from "@mui/material";

import { LocationType } from "@onair/repositories";

export const LOCATION_TYPE_LIST = [
	{
		value: LocationType.ONLINE,
		label: "Sự kiện Online",
		description:
			"Sự kiện được tổ chức trực tuyến.\n" +
			"Cho phép người tham dự tham gia từ bất kỳ đâu chỉ với kết nối internet.",
	},
	{
		value: LocationType.OFFLINE,
		label: "Sự kiện Offline",
		description:
			"Sự kiện tổ chức tại địa điểm thực tế.\n" +
			"Nơi người tham dự gặp gỡ, tương tác và trải nghiệm trực tiếp.",
	},
];

interface PropTypes {
	value: LocationType;
	onChange: (v: LocationType) => void;
	error?: {
		message?: string;
	};
}

export const SelectEventLocationType: React.FC<PropTypes> = (props) => {
	const { value, onChange, error } = props;

	return (
		<Stack spacing={3}>
			<Stack>
				<Stack
					className="rounded-xl"
					direction="row"
					justifyContent="space-between"
					sx={{
						flexWrap: {
							xs: "wrap",
							md: "nowrap",
						},
						p: "10px",
						backgroundColor: "#F4F6F8",
					}}
				>
					{LOCATION_TYPE_LIST.map((el) => {
						const isSelected = value === el.value;
						return (
							<Box
								key={el.value}
								onClick={() => {
									onChange(el.value);
								}}
								sx={{
									cursor: "pointer",
									p: 3,
									width: {
										xs: "100%",
										md: "50%",
									},
									borderRadius: "12px",
									border: `1px solid ${isSelected ? "white" : "#F4F6F8"}`,
									backgroundColor: isSelected ? "white" : "#F4F6F8",
								}}
							>
								<Typography
									color="text.primary"
									mb={0.5}
									fontWeight={700}
									variant="h6"
								>
									{el.label}
								</Typography>
								<Typography color="text.primary" variant="body2">
									{el.description}
								</Typography>
							</Box>
						);
					})}
				</Stack>
				<Typography
					sx={{
						fontSize: "0.75rem",
						fontWeight: 400,
						mt: 1,
						mx: 1.5,
					}}
					variant="subtitle2"
					color="error"
				>
					{error?.message}
				</Typography>
			</Stack>
		</Stack>
	);
};
